import Filter from './Filter';
import TweetBoard from './TweetBoard';
import './Body.css';
import DataBoard from './DataBoard';

const Body = () => {
    const tweets = [
        {
            id: 1,
            name: "John Doe",
            handle: "@johndoe",
            profile_image: "https://www.gravatar.com/avatar/anything?s=200&d=mm",
            message: "This is a random tweet message"
        },
        {
            id: 2,
            name: "John Doe",
            handle: "@johndoe",
            profile_image: "https://www.gravatar.com/avatar/anything?s=200&d=mm",
            message: "This is a random tweet message"
        },
        {
            id: 3,
            name: "John Doe",
            handle: "@johndoe",
            profile_image: "https://www.gravatar.com/avatar/anything?s=200&d=mm",
            message: "This is a random tweet message"
        },
    ]
    return (
        <div id = "bodyContainer">
            <Filter filter={[{id: 0, content: "#GISDEffect"}]}/>
            <div id="resultsContainer">
                <TweetBoard tweets={tweets}/>
                <TweetBoard tweets={tweets}/>
                <DataBoard CXdata={{responsiveness: 5, affordability: 4, branding: 3, quality: 2, accessibility: 1, service: 5}}/>
            </div>
        </div>
    );
}

export default Body;